import React, { useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";

import TopHeader from "components/common/TopHeader";
import HelpPopover from "components/Screens/PaymentV2/PaymentNew/common/Popover";

import { getPlatformConfig } from "selectors/platformConfig";
import { getUserAdditionalInfo } from "selectors/user";
import { usePermissions } from "components/Hook";

function EdgeAtlas() {
  const { loggedInUserType } = usePermissions();
  const platformConfig = useSelector(getPlatformConfig);
  const userInfo = useSelector(getUserAdditionalInfo);

  const notionUrl = useMemo(() => {
    try {
      const edgeAtlasLinks = JSON.parse(platformConfig.payload?.EDGE_ATLAS_NOTION_LINKS || "{}");

      if (loggedInUserType === "customer") {
        const defaultCustomerLink = edgeAtlasLinks.customer?.find((link) => link.industry === null);

        return defaultCustomerLink?.url || "";
      } else if (loggedInUserType === "employee") {
        const userCountry = userInfo?.country;
        const countryLink = edgeAtlasLinks.talent?.find((link) => link.country === userCountry);

        if (!countryLink) {
          const defaultTalentLink = edgeAtlasLinks.talent?.find((link) => link.country === null);
          return defaultTalentLink?.url || "";
        }

        return countryLink?.url || "";
      }

      return "";
    } catch (error) {
      console.error("Error parsing EDGE_ATLAS_NOTION_LINKS:", error);
      return "";
    }
  }, [platformConfig.payload?.EDGE_ATLAS_NOTION_LINKS, loggedInUserType, userInfo?.country]);

  return (
    <>
      <Helmet>
        <title>Edge Atlas</title>
      </Helmet>

      {notionUrl ? (
        <iframe src={notionUrl} width="100%" height="100%" frameBorder="0" allowFullScreen />
      ) : (
        <div>No Edge Atlas URL available</div>
      )}
    </>
  );
}

export default EdgeAtlas;
